import { Control } from "../../business-objects/control/control.model";
import { SelectContactControlConfig } from "./select-contact-control-config.model";

export class SelectContactControl extends Control {
    config: SelectContactControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/select-contact/select-contact-control.model.ts